<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                  <div class="card-header align-items-center border-bottom-dark px-0">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        FAQ Category
                      </h3>
                    </div>
                    <div class="icons d-flex">
                      <button
                        class="btn ml-2 p-0 kt_notes_panel_toggle"
                        data-toggle="tooltip"
                        title="Add FAQ Category"
                        data-placement="right"
                      >
                        <span
                          class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                          v-on:click="display_form = !display_form"
                        >
                          <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="table-responsive" id="printableTable">
                      <div id="faqCategoryTable_wrapper" class="dataTables_wrapper no-footer">
                        <div class="dataTables_length" id="faqCategoryTable_length">
                          <label>
                            Show
                            <select
                              name="faqCategoryTable_length"
                              class=""
                              v-model="limit"
                              v-on:change="fetchCategories()"
                            >
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                            entries
                          </label>
                        </div>
                        <div id="faqCategoryTable_filter" class="dataTables_filter">
                          <label>
                            Search:
                            <input
                              type="search"
                              class=""
                              placeholder=""
                              v-model="searchParameter"
                              @keyup="fetchCategories()"
                            />
                          </label>
                        </div>

                        <table id="faqCategoryTable" class="display dataTable no-footer" role="grid">
                          <thead class="text-body">
                            <tr role="row">
                              <th
                                class="sorting"
                                tabindex="0"
                                @click="sorting('id')"
                                :class="
                                  (sortType == 'asc' || sortType == 'ASC') && sortBy == 'id'
                                    ? 'sorting_asc'
                                    : (sortType == 'desc' || sortType == 'DESC') && sortBy == 'id'
                                    ? 'sorting_desc'
                                    : 'sorting'
                                "
                              >ID</th>
                              <th
                                class="sorting"
                                tabindex="0"
                                @click="sorting('name')"
                                :class="
                                  (sortType == 'asc' || sortType == 'ASC') && sortBy == 'name'
                                    ? 'sorting_asc'
                                    : (sortType == 'desc' || sortType == 'DESC') && sortBy == 'name'
                                    ? 'sorting_desc'
                                    : 'sorting'
                                "
                              >Name</th>
                              <th
                                class="sorting"
                                tabindex="0"
                                @click="sorting('status')"
                                :class="
                                  (sortType == 'asc' || sortType == 'ASC') && sortBy == 'status'
                                    ? 'sorting_asc'
                                    : (sortType == 'desc' || sortType == 'DESC') && sortBy == 'status'
                                    ? 'sorting_desc'
                                    : 'sorting'
                                "
                              >Status</th>
                              <th class="no-sort sorting_disabled">Action</th>
                            </tr>
                          </thead>
                          <tbody class="kt-table-tbody text-dark">
                            <tr
                              class="kt-table-row kt-table-row-level-0 odd"
                              role="row"
                              v-for="category in categories"
                              :key="category.faq_category_id"
                            >
                              <td class="sorting_1">{{ category.faq_category_id }}</td>
                              <td>{{ category.faq_category_name }}</td>
                              <td>
                                <span
                                  :class="category.faq_category_status === 'active' ? 'badge badge-success' : 'badge badge-danger'"
                                >
                                  {{ category.faq_category_status }}
                                </span>
                              </td>
                              <td>
                                <a
                                  href="javascript:void(0)"
                                  class="click-edit"
                                  data-toggle="tooltip"
                                  title="Edit"
                                  @click="editCategory(category)"
                                >
                                  <i class="fa fa-edit"></i>
                                </a>
                                <a
                                  href="javascript:void(0)"
                                  class="ml-2"
                                  data-toggle="tooltip"
                                  title="Delete"
                                  @click="deleteCategory(category.faq_category_id)"
                                >
                                  <i class="fa fa-trash text-danger"></i>
                                </a>
                              </td>
                            </tr>
                            <tr v-if="categories.length === 0">
                              <td colspan="4" class="text-center">No FAQ categories found.</td>
                            </tr>
                          </tbody>
                        </table>

                        <ul class="pagination pagination-sm m-0 float-right">
                          <li :class="[{ disabled: !pagination.prev_page_url }]">
                            <button class="page-link" @click="fetchCategories(pagination.prev_page_url)">Previous</button>
                          </li>
                          <li class="disabled">
                            <a class="page-link text-dark" href="#">
                              Page {{ pagination.current_page }} of {{ pagination.last_page }}
                            </a>
                          </li>
                          <li :class="[{ disabled: !pagination.next_page_url }]" class="page-item">
                            <button class="page-link" @click="fetchCategories(pagination.next_page_url)">Next</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Offcanvas Slide-in Form -->
    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
        <h4 class="font-size-h4 font-weight-bold m-0">
          {{ edit ? 'Edit FAQ Category' : 'Add FAQ Category' }}
        </h4>
        <a
          href="#"
          class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close"
          v-on:click="clearForm()"
        >
          <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
          </svg>
        </a>
      </div>

      <form id="faqCategoryForm">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Name <span class="text-danger">*</span></label>
              <input
                type="text"
                v-model="category.name"
                class="form-control"
                placeholder="Enter category name"
              />
              <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
            </div>
            <div class="form-group">
              <label class="text-dark">Status</label>
              <select v-model="category.status" class="form-control">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="btn btn-primary"
          @click="submittedForm()"
        >
          {{ edit ? 'Update' : 'Save' }}
        </button>
        <button
          type="button"
          class="btn btn-secondary ml-2"
          @click="clearForm()"
        >
          Cancel
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqCategory',
  data() {
    return {
      display_form: false,
      edit: false,
      categories: [],
      pagination: {},
      limit: 10,
      searchParameter: '',
      sortBy: 'id',
      sortType: 'DESC',
      errors: {},
      token: [],
      category: {
        name: '',
        status: 'active',
      },
    };
  },
  mounted() {
    var token = localStorage.getItem('token');
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchCategories();
  },
  methods: {
    fetchCategories(page_url = null) {
      let url = `/api/admin/faq_category?limit=${this.limit}&sortBy=${this.sortBy}&sortType=${this.sortType}`;
      if (this.searchParameter) {
        url += `&searchParameter=${this.searchParameter}`;
      }
      if (page_url) {
        url = page_url + `&limit=${this.limit}&sortBy=${this.sortBy}&sortType=${this.sortType}`;
        if (this.searchParameter) url += `&searchParameter=${this.searchParameter}`;
      }
      axios.get(url, this.token).then((res) => {
        if (res.data.status === 'Success') {
          this.categories = res.data.data || [];
          this.pagination = {
            current_page: res.data.meta.current_page,
            last_page: res.data.meta.last_page,
            prev_page_url: res.data.links.prev,
            next_page_url: res.data.links.next,
          };
        }
      });
    },
    editCategory(category) {
      this.edit = true;
      this.display_form = true;
      this.category = {
        id: category.faq_category_id,
        name: category.faq_category_name,
        status: category.faq_category_status,
      };
    },
    deleteCategory(id) {
      this.$confirm('Are you sure you want to delete this FAQ category?').then(() => {
        axios.delete(`/api/admin/faq_category/${id}`, this.token).then((res) => {
          if (res.data.status === 'Success') {
            this.$toaster.success(res.data.message);
            this.fetchCategories();
          } else {
            this.$toaster.error(res.data.message);
          }
        });
      });
    },
    submittedForm() {
      this.errors = {};
      if (this.edit) {
        axios
          .put(`/api/admin/faq_category/${this.category.id}`, this.category, this.token)
          .then((res) => {
            if (res.data.status === 'Success') {
              this.$toaster.success(res.data.message);
              this.clearForm();
              this.fetchCategories();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.errors = error.response.data.errors;
            }
          });
      } else {
        axios
          .post(`/api/admin/faq_category`, this.category, this.token)
          .then((res) => {
            if (res.data.status === 'Success') {
              this.$toaster.success(res.data.message);
              this.clearForm();
              this.fetchCategories();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.errors = error.response.data.errors;
            }
          });
      }
    },
    clearForm() {
      this.display_form = false;
      this.edit = false;
      this.errors = {};
      this.category = { name: '', status: 'active' };
    },
    sorting(col) {
      if (this.sortBy === col) {
        this.sortType = this.sortType === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortBy = col;
        this.sortType = 'ASC';
      }
      this.fetchCategories();
    },
  },
};
</script>
